import { render, staticRenderFns } from "./CouponOrderList.vue?vue&type=template&id=0cb87586&scoped=true"
import script from "./CouponOrderList.vue?vue&type=script&lang=js"
export * from "./CouponOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb87586",
  null
  
)

export default component.exports